var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEval({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    fill: "none",
    viewBox: "0 0 42 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.931 9h2.6207l3.2759-8h1.9655l0.6552 2-0.6552 3.3333h5.8966l1.3103 1.3333-1.3103 1.3333 1.3103 1.6667-1.3103 1 0.6551 1.3333-1.3103 1.3333 0.6552 1.3334-1.3104 1.3333h-8.5172l-1.9655-1.3333h-1.9655m0-8h-3.931v9.3333h3.931v-9.3333z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m36.655 22.5h-2.8966l-3.6207 8.5h-2.1724l-0.7241-2.125 0.7241-3.5417h-6.5172l-1.4483-1.4166 1.4483-1.4167-1.4483-1.7708 1.4483-1.0625-0.7242-1.4167 1.4483-1.4167-0.7241-1.4166 1.4483-1.4167h9.4137l2.1725 1.4167h2.1724m0 8.5h4.3448v-9.9167h-4.3448v9.9167z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEval);
export default __webpack_public_path__ + "static/media/eval.c83eceb40dacfcc37a8ec534ef38a423.svg";
export { ForwardRef as ReactComponent };